module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "created_at",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "location",
      fn: function(data) {
        return [_c('div', [_c('location-editable', {
          key: data.item.id,
          attrs: {
            "field": "location",
            "value": data.item.location,
            "product-id": data.item.id
          }
        })], 1), _vm._v(" "), _c('div', [_c('small', [_vm._v("\n          Rest:\n          "), _c('field-editable', {
          key: data.item.id,
          attrs: {
            "field": "overstock_location",
            "value": data.item.overstock_location,
            "product-id": data.item.id
          }
        })], 1)])]
      }
    }, {
      key: "in_store",
      fn: function(data) {
        return [_c('in-store-editable', {
          key: data.item.id,
          attrs: {
            "in-store": !!data.value,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "stock_quantity",
      fn: function(data) {
        return [_c('stock-editable', {
          key: data.item.id,
          attrs: {
            "quantity": data.value,
            "product-id": data.item.id
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      },
      "remove": _vm.refresh
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-tag mr-5"
  }), _vm._v(" Producten\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c6e7dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/UnknownProductsPage.vue
// module id = 720
// module chunks = 1